import styled, { css } from 'styled-components';
import { getBaseTheme } from '@Themes';
import { textblocks, buttons } from 'seal-ui-components';

const HelpModalContentBody = styled(textblocks.Section)`
    p {
        margin-bottom: ${getBaseTheme().spaces.default.m};
        font-size: ${getBaseTheme().texts.sizes.s.fontSize};
        line-height: ${getBaseTheme().texts.sizes.s.lineHeight};
    }
`;

export default css`
    .help-modal-header {
        background-color: ${getBaseTheme().colors.area.default.backgroundColor};

        ${buttons.Button} {
            text-transform: none;
        }

        text-transform: capitalize;
        height: 40px;
        margin-bottom: 0;
        padding: 0 ${getBaseTheme().spaces.default.xs} 0 ${getBaseTheme().spaces.default.m};
        box-shadow: 0px 0px 9px 3px rgba(0, 0, 0, 0.13);
    }
`;

HelpModalContentBody.displayName = 'HelpModalContentBody';
export { HelpModalContentBody };
